import React from 'react';
import { defaultTheme } from '@amzn/storm-ui';
import { SvgIconWrapper } from './styles';
import { orange } from 'src/colors';

interface SvgIconProps {
  isSelected?: boolean;
  iconPath: string;
  ariaLabel: string;
  withGradient?: boolean;
}

export const SvgIcon: React.FC<SvgIconProps> = ({
  isSelected,
  iconPath,
  ariaLabel,
}) => {
  const fill = !isSelected ? defaultTheme.color.gray[800] : orange;

  return (
    <>
      <SvgIconWrapper
        src={iconPath}
        key={fill}
        aria-label={ariaLabel}
        preProcessor={(code) => {
          code = code.replace(/filter=".*?"/g, '');
          code = code.replace(/<title>.*<\/title>/g, '');
          code = code.replace(/fill=".*?"/g, `fill="${fill}"`);
          return code;
        }}
      />
    </>
  );
};
